<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <teleport to="body">
    <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" open :modalId="modalId">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" @click="$emit('close')"/>
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-2 pb-2 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
            <slot name="actions">
              <menu class="">
                <base-button
                    @click="$emit('close')"
                    :type="'button'"
                    :class="'px-2 float-right clear-both mb-2 text-xs leading-5 font-semibold rounded-full bg-gray-600 text-white'"
                >
                  Close
                </base-button>
              </menu>
            </slot>
            <slot name="header">
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    {{ title }}
                  </DialogTitle>
                </div>
            </slot>
            <div class="mt-3 sm:mt-5">
              <slot></slot>
            </div>
          </div>
      </div>
    </Dialog>
  </teleport>
</template>

<script>
//import { ref } from 'vue'
import { Dialog, DialogOverlay, DialogTitle } from '@headlessui/vue'
import BaseButton from "./BaseButton";

export default {
  components: {
    BaseButton,
    Dialog,
    DialogOverlay,
    DialogTitle,
  },
  emits: ['close'],
  props: {
    title: {
      type: String,
      required: false,
    },
    modalId:{
      type: String,
      required: false, //todo change to true?
    }
  },
  data(){
    return{
    };
  }
}
</script>